import React from "react";
import { motion } from "framer-motion";
import server from "../../assets/server.webp";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <div className="relative w-full overflow-hidden">
      {/* Grid Background */}
      {/* <div className="absolute inset-0 opacity-20">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute h-full w-[1px] bg-blue-500/30"
            style={{ left: `${i * 5}%`, transition: "opacity 0.3s ease" }}
          />
        ))}
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute h-[1px] w-full bg-blue-500/30"
            style={{ top: `${i * 5}%`, transition: "opacity 0.3s ease" }}
          />
        ))}
      </div> */}

      {/* Content */}
      <div className=" relative z-10 flex h-full flex-col lg:flex-row items-center mt-20">
        {/* Text Content */}
        <div className="max-w-2xl text-center lg:text-left  mt-20 lg:mt-0">
          <h1 className="mb-4 text-4xl sm:text-5xl lg:text-6xl font-bold text-white">
            Fastest Performance
            <br />
            Web Hosting.
          </h1>
          <p className="text-lg text-gray-400 mt-6">
            Enjoy white label reseller hosting powered by cPanel. Our cPanel
            reseller plans provide everything you need....
          </p>
          <button
            className="text-white px-6 py-3 bg-[#339d90] rounded-lg mt-8 hover:bg-[#2a7f74] transition-colors"
            onClick={() => navigate("/about")}
          >
            Read More
          </button>
        </div>

        {/* Image Container */}
        <div className="flex items-center justify-center lg:justify-end w-full mt-12 lg:mt-0">
          <img
            style={{ animationDuration: "3s" }}
            className="h-auto w-[300px] sm:w-[400px] lg:w-[600px] animate-float rounded-lg"
            src={server}
            alt="Server"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
